import { apiRequest } from "src/utils/apiRequest";

/** Mirrors the backend `InspectionUrgency` enum. */
export type InspectionUrgency = "DUE" | "UPCOMING";

/**
 * A scheduled inspection from AUSTIN. GET /inspections/scheduled returns a list
 * of these. Mirrors the backend `ScheduledInspection` model.
 */
export interface ScheduledInspection {
    austinInspectionId: string;
    name: string;
    status: string;
    assignee?: string | null;
    scheduledDateTime?: string | null;
    dueDate?: string | null;
    urgency?: InspectionUrgency | null;
}

class AustinInspectionService {
    /**
     * Fetch the scheduled inspections to surface in the workflow section for a
     * site (the DUE and UPCOMING inspections). Resolves to an empty array when
     * there is nothing to show.
     *
     * @param siteCode Site code selected in the toggle (e.g. "DEMO1").
     */
    async getScheduledInspections(
        siteCode: string
    ): Promise<ScheduledInspection[]> {
        const data = await apiRequest<ScheduledInspection[] | null>({
            url: `/inspections/scheduled`,
            method: "GET",
            params: { site_code: siteCode },
        });
        return data ?? [];
    }
}

export default new AustinInspectionService();
